import { useTheme } from '@mui/material/styles';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export interface ChartProp {
    name: string;
    val: number;
}

interface BarChartProps {
    data: ChartProp[];
}

export default function CountByHourBarChart({ data }: BarChartProps) {
    const theme = useTheme();
    const formatter =  ( value: any ) => { return [value] }; 

    return (
        <ResponsiveContainer >
            <BarChart
                width={500}
                height={300}
                data={data}
                margin={{
                    top: 30,
                    right: 40,
                    left: 20,
                    bottom: 20,
                }}
                barSize={7}
            >
                <CartesianGrid stroke={theme.palette.text.secondary} vertical={false} />
                <XAxis
                    dataKey="name"
                    stroke={theme.palette.text.secondary}
                    tickLine={false}
                    axisLine={false}
                    strokeDasharray="3 3"
                    style={{
                        fontSize: '0.8rem',
                        fontFamily: 'Metropolis',
                        fontWeight: 100
                    }}
                />
                <YAxis
                            stroke='gray'
                            tickLine={false}
                            axisLine={false}
                        />
                <Tooltip cursor={false} formatter={formatter} />
                <Bar dataKey="val" fill={theme.palette.secondary.main} radius={[8, 8, 0, 0]} />
            </BarChart>
        </ResponsiveContainer>
    )
}